<template>
  <div :class="$style.vipCustomer">
    <VipCustomer :isH5="true" :class="$style.window" @close="close"></VipCustomer>
  </div>
</template>

<script>
import VipCustomer from '@/components/VipCustomer'
import { mapMutations } from 'vuex'

export default {
  name: '',
  data () {
    return {
    };
  },
  components: {
    VipCustomer
  },
  methods: {
    ...mapMutations({
      changeUserState: 'user/CHANGE_STATE'
    }),
    close() {
      this.changeUserState({ vipVisible: false })
    }
  }
}
</script>

<style lang="scss" module>
.vipCustomer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  .window {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 370px;
    height: 260px;
  }
}
</style>